import type { Theme } from '@material-ui/core/styles';
import { createTheme as createMuiTheme } from '@material-ui/core/styles';
import type { Theme as GridTheme } from 'styled-bootstrap-grid/dist/components/ThemeProvider/types';
import type { DefaultTheme } from 'styled-components';

import type { JuiTheme } from '@jerry-serverless/jerry-ui/lib/themes/types.juiTheme';
import { defaultTheme as juiDefaultTheme } from '@jerry-serverless/jerry-ui/lib/themes';
import type { PartnerName } from '@jerry-serverless/analyticslib/partner';
import type { FlowType } from '@jerry-serverless/types';

import jerry from './jerry';
import nerdwallet from './partners/nerdwallet';
import fiona from './partners/fiona';
import lyft from './partners/lyft';
import repairEstimate from './repair_estimate';

/**
 * merge material-ui theme into style-components DefaultTheme. so we can access material-ui theme property with theme
 */
declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface DefaultTheme extends Pick<Theme, 'palette'>, GridTheme, JuiTheme {}
}

const ThemeOptions = {
  jerry,
  nerdwallet,
  fiona,
  lyft,
  repairEstimate,
};

export type ThemeName = PartnerName | 'jerry' | FlowType;

/**
 * Creates a theme based on the partner.
 *
 * @param themeName
 */
export const createTheme = (themeName: ThemeName = 'jerry'): Theme => {
  return createMuiTheme(ThemeOptions.jerry, ThemeOptions[themeName], {
    overrides: { MuiButton: { root: { borderRadius: '9999rem' } } },
  });
};

/**
 * Creates a theme based on juiTheme, jerry and then specified by the partner.
 *
 * @param themeName
 */
export const createDefaultTheme = (themeName: ThemeName = 'jerry'): DefaultTheme => {
  const muiTheme = createTheme(themeName);
  const defaultThemeWithMaterialThemeProperty: DefaultTheme = { ...juiDefaultTheme, palette: muiTheme.palette };
  return defaultThemeWithMaterialThemeProperty;
};
